import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import { ConfigContext } from '../config-provider';
const SideBar = (props) => {
    const { getPrefixCls } = useContext(ConfigContext);
    const { prefixCls: customizePrefixCls, indexItems } = props;
    const prefixCls = getPrefixCls('index-bar-sidebar', customizePrefixCls);
    const handleClick = (index) => props.onActive(index);
    return (React.createElement("div", { className: prefixCls }, indexItems.map(({ index, brief }) => {
        const active = index == props.activeIndex;
        return (React.createElement("div", { className: `${prefixCls}-row`, key: index, "data-index": index, onClick: () => handleClick(index) },
            React.createElement("div", { className: classNames(`${prefixCls}-item`, {
                    [`${prefixCls}-item-active`]: active,
                }), "data-index": index },
                React.createElement("div", null, brief))));
    })));
};
export default SideBar;
